import React from 'react'
import { BiLike } from 'react-icons/bi'

export default function Success(props) {
    const {  alert } = props;
    return (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-100 p-4'>
            <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-vox-2xl max-w-md w-full mx-4 overflow-hidden'>
                <div className="p-8 text-center">
                    <div className="w-16 h-16 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center mx-auto mb-6">
                        <BiLike className="w-8 h-8 text-green-600 dark:text-green-400" /> 
                    </div>
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4"> {alert.title} </h1>
                    <span className='text-gray-600 dark:text-gray-400 block'> {alert.placeholder} </span>
                </div>
                <div className="p-6 bg-gray-50 dark:bg-gray-700" >
                    <button 
                        className="w-full px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-xl font-semibold transition-colors duration-200 shadow-vox hover:shadow-vox-lg" 
                        onClick={props.quitAlert}
                    >
                        Ok
                    </button>
                </div>
            </div>
        </div>
    )
}
